export const dictionary = {
    id: 'Ідентифікатор',
    longitude: 'Довгота',
    latitude: 'Широта',
    battery: 'Заряд батареї, %',
    status: 'Статус',
    pending: 'Очікування',
    phone: 'Номер телефону',
    datetime: 'Дата і час події',
    altitude: 'Висота, м',
    accuracy: 'Точність, м',
    inProgress: 'В роботі',
    finished: 'Завершено',
    comment: 'Коментар',
    firstName: `Ім'я`,
    lastName: 'Прізвище',
    birthDate: 'Дата народження',
    bloodType: 'Група крові',
    rh: 'Резус фактор',
    illnesses: 'Критичні захворювання',
    allergies: 'Алергії на медичні препарати',
    drugs: 'Медикаментозна залежність',
    deafness: 'Інвалідність',
    emergencyContact: 'Контактна особа',
    finishReason: 'Причина завершення',
    finishedAt: 'Дата і час завершення',
    source: `Канал зв'язку`,
    notes: 'Нотатки',
    state: 'Область'
};
